import { PageTitle, PageTitleContainer } from "@/ui-components/utils/menu-items/page-title";
import InvoicesEditor from "../invoices-editor";

const DeleteInvoice = () => {
  return (
    <div>
      <PageTitleContainer>
        <div className="flex flex-row justify-between items-center">
          <PageTitle>Rechnungen löschen</PageTitle>
        </div>
      </PageTitleContainer>
      <div className="p-4 w-1/2 items-center m-auto">
        <InvoicesEditor type="delete" />
      </div>
    </div>
  );
};

export default DeleteInvoice;
